<template>
    <multiselect
        class="shop__menu-bar__sort shop__multiselect"
        v-model="value"
        openDirection="below"
        :searchable="false"
        :show-labels="false"
        :options="options"
        track-by="name"
        label="name"
        :allow-empty="false"
        />
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: 'SortDropdown',
    components: { Multiselect },
    data() {
        return {
            options: [
                { name: 'Most popular', key: 'default' },
                { name: 'Price low to high', key: 'low-high' },
                { name: 'Price high to low', key: 'high-low' },
            ],
        };
    },
    computed: {
        value: {
            get() {
                return this.$store.getters['shop/getSortMethod'];
            },
            set(value) {
                this.$store.commit('shop/setSortMethod', value);
            },
        },
    },
};
</script>
